import { Icon, Tag } from '@ps/isp-web-component-library';
import type { EventType } from '@ps/isp-web-services-types';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';

import { TXTWCL_This_popular_accumulator_has_b_ELL } from './PopularAccumulatorCount.messages.json';
import styles from './PopularAccumulatorCount.scss';

const PopularAccumulatorCount = ({
  count,
  eventTypeId
}: {
  count: number;
  eventTypeId: EventType;
}) => {
  const { formatMessage } = useRegulatoryIntl();
  const icon = getEventTypeIcon(eventTypeId);

  return (
    <div className={styles.accumulatorIcon} data-testid="accumulator-counter">
      <Icon
        icon={icon}
        size="x2"
        label={formatMessage(TXTWCL_This_popular_accumulator_has_b_ELL, { 0: count })}
      />
      <Tag className={styles.accumulatorIconBadge}>{count}</Tag>
    </div>
  );
};

export default PopularAccumulatorCount;
